<template>
  <div class="account">
    <span
      :class="['close-account', { 'close-account-active': active }]"
      @click="changeAccout"
      >खाता बंद करें</span
    >
  </div>
</template>
<script>
export default {
  data() {
    return {
      active: false,
    };
  },
  methods: {
    changeAccout() {
      this.active = true;
      this.$router.push("/helpFeedback?type=contact");
    },
  },
};
</script>
<style scoped>
.account {
  margin-left: 40.625px;
  width: 418.75px;
  height: 73.125px;
  border: 0.625px solid #dddddd;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}
.close-account {
  font-size: 10px;
  padding-bottom: 5px;
  border-bottom: 0.625px solid #232323;
  color: #232323;
  cursor: pointer;
}
.close-account-active {
  border-bottom: 0.625px solid #2e67ea;
  color: #2e67ea;
}
</style>
<style scoped>
@media only screen and (max-width: 1100px) {
  .account {
    width: 337.5px;
  }
}
@media only screen and (max-width: 900px) {
  .account {
    margin-left: 10px;
  }
}
@media only screen and (max-width: 768px) {
  .account {
    margin-left: auto;
    margin-right: auto;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mycom/account.vue